import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'wageValue', standalone: true })
export class WageValuePipe implements PipeTransform {
  transform(value: number | string, digits = 2): string {
    return Number(value).toFixed(digits).replace('.', ',');
  }
}
